import Swiper from 'swiper';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

document.addEventListener('DOMContentLoaded', function () {
    const player = new Plyr('#player', {
        controls: [
            'play-large',
            'play',
            'progress',
            'current-time',
            'duration',
            'mute',
            'volume',
            'captions',
            'settings',
            'fullscreen'
        ],
        resetOnEnd: false,
        hideControls: true,
        keyboard: { focused: true, global: true },
        clickToPlay: false,
        tooltips: { controls: true, seek: true },
        iconUrl: '/wp-content/themes/gardahelp/assets/images/vendor/plyr/plyr.svg',
        blankVideo: '/wp-content/themes/gardahelp/assets/videos/blank.mp4',
    });
    
    const videoOverlay = document.getElementById('video-overlay');
    const playButton = document.getElementById('play-button');
    
    if (playButton && videoOverlay) {
        playButton.addEventListener('click', function() {
            player.play();
            fadeOutOverlay();
        });
    }
    
    function fadeOutOverlay() {
        if (videoOverlay) {
            videoOverlay.style.opacity = '0';
            setTimeout(() => {
                videoOverlay.style.display = 'none';
            }, 500);
        }
    }
    
    player.on('play', function() {
        fadeOutOverlay();
    });
    
    player.on('pause', function() {
        fadeOutOverlay();
    });
    
    player.on('ended', function() {
        if (videoOverlay) {
            videoOverlay.style.display = 'flex';
            setTimeout(() => {
                videoOverlay.style.opacity = '1';
            }, 10);
        }
    });
    
    player.on('enterfullscreen', function() {
        document.documentElement.classList.add('plyr-fullscreen');
    });
    
    player.on('exitfullscreen', function() {
        document.documentElement.classList.remove('plyr-fullscreen');
    });

    const scrollLinks = document.querySelectorAll('a[href^="#"]');
    scrollLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 80,
                    behavior: 'smooth'
                });
            }
        });
    });

    const teamSlider = new Swiper('.team-slider', {
        modules: [Autoplay, EffectCoverflow],
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        speed: 1500,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 200,
            modifier: 1,
            slideShadows: false,
        }
    });
});